import React, {useEffect,useRef, useState} from "react";
import {  useParams } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import '@fontsource/roboto';
import Button from '@material-ui/core/Button';
import FormBehavior from "../surveyforms/FormBehavior";
import { Typography } from "@material-ui/core";
import $ from 'jquery';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import ButtonGroup from '@material-ui/core/ButtonGroup';



const useStyles = makeStyles((theme )=> ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  },
  surveyHolder:{
    width:'80%',
    background: 'white',
    padding: '20px',
    border: '1px lightblue solid',
    margin: 'auto'
  },
  radio:{
    marginBottom: 0,
    paddingBottom: 0
  },
  radiogroup:{
    marginLeft: '20px'
  },
  label: {
      fontSize: '14px'
  },
  prompt:{
    marginTop: '10px',
    fontSize: '20px',
    fontWeight: 500,
  },
  card:{
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '3px',
    marginBottom: '5px',
    paddingBottom: '5px'
  },
  card_guide:{
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '3px',
    marginTop: '15px',
    paddingBottom: '5px',
    marginBottom: '5px'
  },
  guide_prompt:{
    lineHeight: 1.5,
    fontSize: '18px'
  },
  red:{
    color: 'red'
  }
}));

export default function PreSurvey(props){
  let { postno, condition } = useParams();
  postno=parseInt(postno);
  const classes=useStyles();
  const [all_questions, setAllQuestions]=useState([]);
  const [questions, setQuestions]=useState([]);
  const [page, setPage]=useState(1);

  useEffect(()=>{
    const username = localStorage.getItem('username');
    $.ajax({
      url:'/api/check-troll/',
      method: 'GET',
      data: {'username':username},
      success: function(res){
        if(res.is_troll){
          window.location='/end/';
        }
        else{
          console.log("new")
        }
        },
      error: function(err){
        console.log('error!')
      },
    })
    $.ajax({
      url:'/api/get-survey/',
      method: 'GET',
      data: {'post_no':postno, 'condition': 'all', 'survey': 'pre', 'username':username},
      success: function(res){
        console.log('res',res)
        setAllQuestions(res.questions);  
        },
      error: function(err){
        console.log('error!')
      },
    })
  },[]);

  const handleChange = (event, idx) => {
    setQuestions((questions)=>{
      questions[idx].response=parseInt(event.target.value);
      return [...questions]})
  };

  const handleNext = () =>{
    // check if all answered 
    var values=questions.map(question => question.response);
    if(values.includes("")){
      var idx=values.indexOf("");
      console.log(idx)
      setQuestions((questions)=>{
        questions[idx].status=false;
        return [...questions]
      })
      window.alert("Please answer every questions.")
    }else{
      const username = localStorage.getItem('username');
      $.ajax({
        url:'/api/save-survey-answers/',
        method: 'POST',
        data: {'post_no': postno, 'username': username, 'condition': 'all', 'questions': questions.map(question=>question.id), 'answers': questions.map(question=>question.response)},
        success: function(res){
          if(page==6){
            checkAttention();
          }else{
            setPage(page+1);
            window.scrollTo(0, 0);
          }
        },
        error: function(err){
          console.log('error!')
        },
      })

      //save and go to next
    }

  }

  const checkAttention=()=>{
    const username = localStorage.getItem('username');
    $.ajax({
      url:'/api/check-attention/',
      method: 'GET',
      data: {'post_no': postno, 'username': username},
      success: function(res){
        if(res.pass){
          window.location='/instruction/'+postno+'/'+condition+'/';
        }else{
          window.location='/end/';
        }
      },
      error: function(err){
        console.log('error!')
      },
    })
  }
  const handlePrev = () =>{
    setPage(page-1);
  }

  const gotoNext = ()=>{
    
  }


  useEffect(()=>{
    const username = localStorage.getItem('username');
    setQuestions(all_questions.filter(question => question.page==page))
    }, [all_questions, page]);

  const behavior_options=[
    'Never',
    'Less than once a week',
    'Once a week',
    'Less than once a day but several times a week',
    'At least once a day',
    'Several times a day'
  ]
  const similarity_options=[
      '1: Extremely dissimilar',
      '2: Quite disimilar',
      '3: Slightly dissimilar',
      '4: Neither',
      '5: Slightly similar',
      '6: Quite similar',
      '7: Extremely similar'
  ]
  const likert_options=[1,2,3,4,5,6,7]
  return(
    <div className={classes.surveyHolder}>
      <Typography variant='h5'>Pre-survey (page {page}/6)</Typography>
      {questions.map((question, idx)=>{
        return(
          <div key={question.prompt}>
          {question.form==='guide'?
          <Paper variant='outlined' elevation={1} className={classes.card_guide}>
          <Typography variant='h6' className={classes.guide_prompt}>{question.prompt}</Typography>
          </Paper>
          :
          <Paper elevation={0} className={classes.card}  >
            {question.status?
            <Typography variant='body1'> <span>Q. {question.prompt}</span> </Typography>
            :
            <Typography variant='body1' className={classes.red}> <span>Q. {question.prompt}</span> (Please answer this question.) </Typography>
            }
            <Typography variant='caption'> {question.description}</Typography>
            <div>
            {question.form==='behavior'? 
              <FormControl component="fieldset" >
              <RadioGroup className={classes.radiogroup} size='small' aria-label="freq" name="freq" value={question.response} onChange={(event)=>handleChange(event,idx)}>
              {behavior_options.map((option, option_idx)=>{
                return(<FormControlLabel classes={{label: classes.label}}  size='small' key={'question-'+idx+'-'+option_idx} value={option_idx+1} control={<Radio size='small'/>} label={option} />)
              })}
              </RadioGroup>
            </FormControl>
            
            : null 
            }
            {question.form==='similarity'? 
              <FormControl component="fieldset" >
              <RadioGroup className={classes.radiogroup} size='small' aria-label="freq" name="freq" value={question.response} onChange={(event)=>handleChange(event,idx)}>
              {similarity_options.map((option, option_idx)=>{
                return(<FormControlLabel classes={{label: classes.label}}  size='small' key={'question-'+idx+'-'+option_idx} value={option_idx+1} control={<Radio size='small'/>} label={option} />)
              })}
              </RadioGroup>
            </FormControl>
            
            : null 
            }
            {question.form==='likert'? 
              <FormControl component="fieldset" >
              <RadioGroup row className={classes.radiogroup} size='small' aria-label="freq" name="freq" value={question.response} onChange={(event)=>handleChange(event,idx)}>
              {likert_options.map((option, option_idx)=>{
                return(<FormControlLabel classes={{label: classes.label}}  size='small' key={'question-'+idx+'-'+option_idx} value={option_idx+1} control={<Radio size='small'/>} label={option} labelPlacement='top' />)
              })}
              </RadioGroup>
            </FormControl>
            
            : null 
            }
            </div>
          </Paper>
      }
          </div>
        )})}
        <div style={{textAlign: 'center'}}>
            <ButtonGroup color="primary" variant="contained" aria-label="outlined primary button group">
              <Button onClick={handlePrev} disabled={page===1}>Prev</Button>
              <Button onClick={handleNext}>{page===6? 'Submit': 'Next'}</Button>
            </ButtonGroup>
        </div>
      </div>
  )
}
